<template>
  <div>
    <BaseHeadline
      :showOnMobile="true"
      icon="mdi-account"
      headerName="Kontakter"
    >
    </BaseHeadline>

    <Searchbar class="mt-4 mb-4" v-model="search" label="Søk kontaktperson" />

    <v-data-table
      :headers="headers"
      :items="contacts"
      item-key="index"
      sort-by="name"
      group-by="contactGroup"
      class="elevation-1"
      :items-per-page="-1"
      hide-default-footer
      :mobile-breakpoint="0"
      :single-expand="false"
      :expanded.sync="expanded"
      :show-expand="$vuetify.breakpoint.smAndDown"
    >
      <template v-slot:group.header="{ headers, group, toggle, isOpen }">
        <td :colspan="100" @click="toggle">
          <v-btn icon :ref="group">
            <v-icon small>
              {{ isOpen ? "mdi-arrow-up" : "mdi-arrow-down" }}
            </v-icon>
          </v-btn>
          {{ group }}
        </td>
      </template>
      <template v-slot:item.contactPersonPersonMobile="{ item }">
        <a :href="`tel:${item.contactPersonPersonMobile}`">
          {{ item.contactPersonPersonMobile }}
        </a>
      </template>

      <template v-slot:item.contactPersonPersonEmail="{ item }">
        <a :href="`mailto:${item.contactPersonPersonEmail}`">
          {{ item.contactPersonPersonEmail }}
        </a>
      </template>

      <template v-slot:expanded-item="{ headers, item }">
        <td class="px-0" colspan="3">
          <v-simple-table class="removeBorderRadiusDataTable">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Firma</td>
                  <td>{{ item.contactName }}</td>
                </tr>
                <tr>
                  <td>Mobiltelefon</td>
                  <td>
                    <a :href="`tel:${item.contactPersonPersonMobile}`">
                      {{ item.contactPersonPersonMobile }}
                    </a>
                  </td>
                </tr>
                <tr>
                  <td>E-post</td>
                  <td>
                    <a :href="`mailto:${item.contactPersonPersonEmail}`">
                      {{ item.contactPersonPersonEmail }}
                    </a>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </td>
      </template>
    </v-data-table>
  </div>
</template>
<script lang="ts">
import Vue from "vue";
import projectApi from "@/api/projectApi";
import { ProjectContactsObject } from "@/types/projectInterface";

import BaseHeadline from "@/components/shared/BaseHeadline.vue";
import Searchbar from "@/components/shared/search/Searchbar.vue";

export default Vue.extend({
  data() {
    return {
      expanded: [],
      search: "",
      projectsContacts: [] as Array<ProjectContactsObject>,
    };
  },

  async mounted() {
    var projectid = this.$route.params.id;
    await projectApi.getProjectContacts(projectid).then((x) => {
      this.projectsContacts = x;
      this.projectsContacts.forEach((y, index) => {
        y.index = index;
      });
    });
    this.toggleAll();
  },

  methods: {
    toggleAll() {
      Object.keys(this.$refs).forEach((k) => {
        (this as any).$refs[k].$el.click();
      });
    },
  },

  computed: {
    contacts(): Array<ProjectContactsObject> {
      if (this.search) {
        return this.projectsContacts.filter((x) =>
          x.contactPersonPersonFullName
            ? x.contactPersonPersonFullName
                .toLowerCase()
                .startsWith(this.search.toLowerCase())
            : false
        );
      }
      return this.projectsContacts;
    },
    headers() {
      if (this.$vuetify.breakpoint.mdAndUp) {
        return [
          { text: "kategori", value: "contactGroup" },
          {
            text: "Firma",
            align: "start",
            value: "contactName",
            groupable: false,
          },
          {
            text: "Kontaktperson",
            value: "contactPersonPersonFullName",
            groupable: false,
          },
          { text: "Rolle", value: "projContactRole", groupable: false },
          {
            text: "Mobiltelefon",
            value: "contactPersonPersonMobile",
            groupable: false,
          },
          {
            text: "E-post",
            value: "contactPersonPersonEmail",
            groupable: false,
          },
        ];
      }

      return [
        { text: "kategori", value: "contactGroup" },
        {
          text: "Kontaktperson",
          value: "contactPersonPersonFullName",
          groupable: false,
        },
        { text: "Rolle", value: "projContactRole", groupable: false },
      ];
    },
  },
  components: {
    BaseHeadline,
    Searchbar,
  },
});
</script>

<style lang="scss" scoped>
.removeBorderRadiusDataTable {
  border-radius: 0px;
}
</style>
